/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'instruments/music-stand': {
    width: 16,
    height: 16,
    viewBox: '0 0 453.499 453.499',
    data: '<path pid="0" d="M301.061 30.108C301.04 30.086 266.993.96 266.993.96a4.001 4.001 0 00-5.199 6.08l25.775 22.037h-56.82V18.538a4 4 0 00-8 0v10.539h-56.82L191.705 7.04a4 4 0 10-5.2-6.08s-34.045 29.126-34.067 29.147a3.974 3.974 0 00-1.343 2.97v61.269a4 4 0 004 4h67.653V335.86l-67.896 78.694a4 4 0 006.058 5.227l40.954-47.468 20.885 13.683V449.5a4 4 0 008 0v-63.51l20.883-13.681 40.956 47.471a4 4 0 006.058-5.227l-67.897-78.695V98.346h67.654a4 4 0 004-4V33.077a3.974 3.974 0 00-1.342-2.969zm-93.925 336.095l15.614-18.097v28.326l-15.614-10.229zm39.225-.004l-15.611 10.227v-28.321l15.611 18.094zm-8.779-329.122h56.821v48.585l-56.821-48.585zm-21.665 0l-56.821 48.585V37.077h56.821zm-49.988 53.269l56.82-48.585v48.585h-56.82zm64.82-48.586l56.821 48.585h-56.821V41.76z"/>'
  }
})
